import { createSelector } from 'reselect'

const mediaSelector = createSelector(
	[ state => state.interactiveVideoCreation.media ],
	media => media
)

export default mediaSelector
